import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/service/api.service';

@Component({
  selector: 'app-avaliacao-auditor',
  templateUrl: './avaliacao-auditor.component.html',
  styleUrls: ['./avaliacao-auditor.component.css']
})
export class AvaliacaoAuditorComponent implements OnInit {
  idempresa: string;
  row_data: any;
  totalvalor: number = 0;
  qderesp: number = 0;
  notafinal: number = 0;
  nota5: string = "";
  nota4: string = "";
  nota3: string = "";
  nota2: string = "";
  nota1: string = "";
  icon5: boolean = false;
  icon4: boolean = false;
  icon3: boolean = false;
  icon2: boolean = false;
  icon1: boolean = false;
  oculto: boolean = false;
  filtro: string;
  loading: any;
  jsonArray: any;
  jsonArrayQde: any;
  nomeempresa: string;
  local: string;
  valornota: string = "0";
  alertanaoapto: boolean = false;
  alertaapto: boolean = false;

  constructor(private activatedRoute: ActivatedRoute, private apiService: ApiService, private spinner: NgxSpinnerService, private toastr: ToastrService, private router: Router) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      this.idempresa = params['id'];
    });

    this.nota1 = "";
    this.nota2 = "";
    this.nota3 = "";
    this.nota4 = "";
    this.nota5 = "";

    this.icon5 = false;
    this.icon4 = false;
    this.icon3 = false;
    this.icon2 = false;
    this.icon1 = false;
    this.row_data = [];

    this.spinner.show();
    this.totalNotas();
  }

  totalQuestao() {
    this.spinner.show();
    this.apiService.getListagemId('empresaavaliacaoquestao', this.idempresa)
      .subscribe(
        (data) => { //start of (1)

          this.jsonArrayQde = data;

          this.qderesp = parseInt(this.jsonArrayQde[0].qde);

          if (isNaN(this.qderesp)) {
            this.qderesp = 0;
          }

          this.totalNotas();

        }, //end of (1)
        (error: any) => {
          this.spinner.hide();
          console.log(JSON.parse(JSON.stringify(error)))
        }, //(2) second argument
        () => {
          this.spinner.hide();
        } //(3) second argument
      );
  }

  totalNotas() {
    this.apiService.getListagemId('empresaavaliacaocompleta', this.idempresa)
      .subscribe(
        (data) => { //start of (1)

          this.jsonArray = data;

          this.nomeempresa = this.jsonArray[0].nome;
          this.local = this.jsonArray[0].cidade + " - " + this.jsonArray[0].estado;
          this.notafinal = parseFloat(this.jsonArray[0].nota);

          this.totalvalor = this.notafinal;

          /*if (this.totalvalor <= 25) {
            this.icon1 = true;
            this.alertanaoapto = true;
            this.alertaapto = false;
          } else if (this.totalvalor > 25 && this.totalvalor < 50) {
            this.icon2 = true;
            this.alertanaoapto = true;
            this.alertaapto = false;
          } else if (this.totalvalor >= 50 && this.totalvalor < 75) {
            this.icon3 = true;
            this.alertanaoapto = true;
            this.alertaapto = false;
          } else if (this.totalvalor >= 75) {
            this.icon4 = true;
            this.alertanaoapto = false;
            this.alertaapto = true;
          }*/

          if (this.totalvalor <= 5) {
            this.icon1 = true;
            this.alertanaoapto = true;
            this.alertaapto = false;
          } else if (this.totalvalor > 5 && this.totalvalor < 7) {
            this.icon2 = true;
            this.alertanaoapto = true;
            this.alertaapto = false;
          } else if (this.totalvalor >= 7 && this.totalvalor < 10) {
            this.icon3 = true;
            this.alertanaoapto = true;
            this.alertaapto = false;
          } else if (this.totalvalor >= 10) {
            this.icon4 = true;
            this.alertanaoapto = false;
            this.alertaapto = true;
          }

          setTimeout(() => {
            this.spinner.hide();
          }, 450);

          //this.calcularMedia();

        }, //end of (1)
        (error: any) => {
          this.spinner.hide();
          console.log(JSON.parse(JSON.stringify(error)))
        }, //(2) second argument
        () => {
          this.spinner.hide();
        } //(3) second argument
      );
  }

  calcularMedia() {
    if (this.qderesp <= 0) {
      this.totalvalor = 0;
    } else {
      this.totalvalor = (this.notafinal / this.qderesp) * 100;
    }

    console.log(this.totalvalor);

    if (this.totalvalor <= 5) {
      this.icon1 = true;
    } else if (this.totalvalor > 5 && this.totalvalor < 7) {
      this.icon2 = true;
    } else if (this.totalvalor >= 7 && this.totalvalor < 10) {
      this.icon3 = true;
    } else if (this.totalvalor >= 10) {
      this.icon4 = true;
    }

    this.valornota = this.totalvalor.toFixed(0);

    setTimeout(() => {

      console.log(parseInt(this.valornota));

      if (parseInt(this.valornota) < 10) {
        this.alertaapto = true;
      } else {
        this.alertaapto = false;
      }

      this.spinner.hide();
    }, 450);

  }

  solictarSelo() {
    console.log(this.alertaapto);
    if (this.alertaapto) {
      this.toastr.warning('Estabelecimento não atingiu a pontuação de adequação  para a aquisição do SELO DE CONFORMIDADE CVale Seg TOP, entre em contato com nossa área de apoio para orientações sobre o procedimento: ambiente.seguro@alcertifcacoes.com.br - (19) 99628 3148');
    } else {
      var url = "https://ambienteseguro.app.br/selo/pagseguro.php?v=" + this.idempresa;
      window.open(url, '_blank');
    }
  }

  abrirManual() {
    window.open('https://ambienteseguro.app.br/manual/MANUAL%20AMBIENTE%20SEGURO%20EDITADO.pdf', '_blank');
  }

  recusarAvaliacao() {
    this.spinner.show();
    this.apiService.getListagemId('recusaravaliacao', this.idempresa)
      .subscribe(
        (data) => { //start of (1)

          this.spinner.hide();
          this.voltarHome();

        }, //end of (1)
        (error: any) => {
          this.spinner.hide();
          console.log(JSON.parse(JSON.stringify(error)))
        }, //(2) second argument
        () => {
          console.log('all data gets')
        } //(3) second argument
      );
  }

  aprovarAvaliacao() {
    this.spinner.show();
    this.apiService.getListagemId('aprovaravaliacao', this.idempresa)
      .subscribe(
        (data) => { //start of (1)

          this.spinner.hide();
          this.voltarHome();

        }, //end of (1)
        (error: any) => {
          this.spinner.hide();
          console.log(JSON.parse(JSON.stringify(error)))
        }, //(2) second argument
        () => {
          console.log('all data gets')
        } //(3) second argument
      );
  }

  voltarHome() {
    this.router.navigate(['/empresas-auditar'], { replaceUrl: true });
  }

  reprovarValidcao() {
    this.spinner.show();
    this.apiService.getListagemId('emailreprovado', this.idempresa)
      .subscribe(
        (data) => { //start of (1)

          this.spinner.hide();
          this.voltarHome();

        }, //end of (1)
        (error: any) => {
          this.spinner.hide();
          this.voltarHome();
          console.log(JSON.parse(JSON.stringify(error)))
        }, //(2) second argument
        () => {
          console.log('all data gets')
        } //(3) second argument
      );
  }

}
